module.exports = __webpack_public_path__ + "static/img/home-book-cover.26f4eee3.png";